export const createRiskMatrixService = (fetch) => async ({ riskMatrix }) => {
  try {
    const response = await fetch({
      url: "/api/v1/matriz-riesgo",
      method: "post",
      body: riskMatrix
    })

    return response.message
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message)
  }
}
